import React, { useState, useEffect } from "react";
import { columnsSatellite } from "./../../constants/dataColumns.jsx";
import TableauSatellite from "./tableauSatellite.jsx";
import MenuAdmin from './../menu/menuAdmin.jsx';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import NumericInput from 'react-numeric-input';
import AuthService from "../../services/auth.service";
import authHeader from "../../services/auth-header";
import { displayAlertMessage } from './../../constants/alertMessage.jsx';

function refrech(){
    window.location.reload() ;

}
export function Satellite() {
    const [satelitteData, setSatelliteData] = useState([]);
    const [satelitteDetail, setSatelliteDetail] = useState([]);
    const [satelitteBw, setSatelitteBw] = useState([]);
    const currentUser = AuthService.getCurrentUser();
 
    if (currentUser == null) {
        window.open("./login", "_self");
    }
    useEffect(() => {

    function fetchData(){

        fetch('/lineup/api/satellite/')
        .then(response => {
            response.json().then(data => {
                setSatelliteData(data)          
            })
    
            
        }).catch(err => {
            console.log("Erreur lors de la récupération des données satellites");
            console.log(err)
        })
      fetch('/lineup/api/satelliteBw/bw')
    .then(response => {
        response.json().then(data => {
            setSatelitteBw(data)          
        })

        
    }).catch(err => {
        console.log("Erreur lors de la récupération des données satellitesBw");
        console.log(err)
    })

    }    
   
    fetchData();
}, []);
    const UpdateSatellite = (event) => {
        const aliasSatellite = document.getElementById('aliasSatellite').value;
        const order = document.getElementById('order').value;
        const actif = document.getElementById('actif').value;
        const satelliteLaunch = document.getElementById('satelliteLaunch').value;
        const satelliteExpectedEOL = document.getElementById('satelliteExpectedEOL').value;
        const status = document.getElementById('status').value;
        const formData = new FormData();
        formData.append('id', satelitteDetail.id);
        formData.append('aliasSatellite', aliasSatellite);
        formData.append('order', order);
        formData.append('actif', actif);
        formData.append('satelliteLaunch', satelliteLaunch);
        formData.append('satelliteExpectedEOL', satelliteExpectedEOL);
        formData.append('status', status);
        console.log(formData);

        fetch('/lineup/api/satellite/edit/editSatellite/', {
            mode: 'cors',
            method: "POST",
            headers: authHeader(),
            body: formData
        }).then(function (res) {
         //   console.log(body);
            if (res.ok) {

                displayAlertMessage("alert alert-success", "Le Satellite a bien été enregistrée")
            } else if (res.status == 401) {
                displayAlertMessage("alert alert-danger", "Erreur lors de l'enregistrement de Le Satellite")
            }
            refrech();
        }, function (e) {
            console.log("Error ");
            console.log(e);
        });
    }



    return (
       
        <div>
        <header className="App-header">
            <div className="bg-black" >
                <MenuAdmin></MenuAdmin>
            </div>
        </header>
        <br />

        <div>

      
             <div className="container">
                    <TableauSatellite satellite={satelitteData} columns={columnsSatellite}  onChangeValue={(data) => {
                        setSatelliteDetail(data.row)
                        }}></TableauSatellite>
              </div>

        <br />
        <br />
        

     <div className="container">
     <Form>           
            <Row >
              <div id="alertMessage"></div>
              <div className="col-md-4 mb-3">
                 <label for="satellite">Satellite</label>
                 <input type="text" className="form-control" id="satellite"  value={satelitteDetail.name}  disabled/>
                    <br />
                    
                
                </div>
                <div className="col-md-4 mb-3">
                <label for="aliasSatellite">Alias Satellite</label>
                <Form.Select id="aliasSatellite" className="rounded-0 shadow">
                      <option value="">Alias Satellite</option>
                      {
                        satelitteBw.map(satellite => (
                          <option key={satellite.id}>{satellite.name}</option>
                        ))
                      }
                    </Form.Select > 
                    </div>

                    <div className="col-md-4 mb-3">
                 <label for="satelliteLaunch">Satellite Launch</label>
                 <input type="text" className="form-control" id="satelliteLaunch"  defaultValue ={satelitteDetail.satelliteLaunchYear}  />
                    <br />
                    
                
                </div>
                        
                </Row> 
                <Row >
           
              <div className="col-md-4 mb-3">
                 <label for="actif">actif Satellite</label>
                 <br />
                 <Form.Select id="actif" className="rounded-0 shadow" >
                      <option defaultValue={satelitteDetail.actifSatellite}>{satelitteDetail.actifSatellite}</option> 
                      <option value="NON">NON</option>
                      <option value="OUI">OUI</option>                    
                     
                    </Form.Select > 
                  
                    
                
                </div>
                <div className="col-md-4 mb-3">
                <label for="order">order satellite</label>
                <br />               
                <NumericInput id="order" min={0} max={100} value={satelitteDetail.orderSatellite}/>
                </div>
             
                    <div className="col-md-4 mb-3">
                 <label for="satelliteExpectedEOL">satellite ExpectedEOL</label>
                 <input type="text" className="form-control" id="satelliteExpectedEOL"  defaultValue={satelitteDetail.satelliteExpectedEOL}  />
                    <br />
                    
                
                </div>  
                </Row> 
                <Row >
                <div className="col-md-4 mb-3">
                 <label for="status">Status Satellite</label>
                 <br />
                 <Form.Select id="status" className="rounded-0 shadow">
                     <option defaultValue={satelitteDetail.status}>{satelitteDetail.status}</option> 
                      <option value="TRAITE">TRAITE</option>
                      <option value="NON_TRAITE">NON TRAITE</option>
                     
                    </Form.Select > 
                                                     
                </div>

                </Row>

                <div className="col">
                <Button onClick={() => UpdateSatellite()}>Modifier</Button>
             
               </div>
                              
            </Form>
      </div>

   </div>
   </div>
    );

}
export default Satellite;
